import { InformationCircleIcon } from "@heroicons/react/outline";
import React from "react";
import { BasicTooltip } from "./Tooltip";

interface HelpTooltipProps {
  content: string;
  icon?: React.ReactNode;
  iconClassName?: string;
  onClick?: () => void;
}

const HelpTooltip: React.FC<HelpTooltipProps> = ({
  content,
  icon = <InformationCircleIcon />,
  iconClassName = "ml-2 h-4 w-4 hover:text-blue-400 transition-colors duration-200 ease-in-out",
  onClick,
}) => {
  return (
    <div className="group relative inline-flex">
      <BasicTooltip content={content}>
        <span
          className={`inline-flex ${
            onClick ? "cursor-pointer" : "cursor-help"
          }`}
          onClick={onClick}
        >
          {React.cloneElement(icon as React.ReactElement, {
            className: `${iconClassName} group-hover:text-blue-500`,
          })}
        </span>
      </BasicTooltip>
    </div>
  );
};

export default HelpTooltip;
